import { useEffect, useState } from "react";
import "../styles/ActivarCuenta.css";
import SidebarActivarCuenta from "../../../../components/sidebar/SidebarActivarCuenta";

export const ActivarCuenta = ({
  infoApi,
  setMostrarLogin,
  setShowModalActivaSuccess,
  setObjUsuarioLogin,
  setLoading,
}) => {
  const [mostrarModalActivarCuenta, setMostrarModalActivarCuenta] =
    useState(false);
  const [urlApi, setUrlApi] = useState("");
  const [codRecaptcha, setCodRecaptcha] = useState("");

  const openActivarCuenta = () => {
    setMostrarModalActivarCuenta(true);
  };

  useEffect(() => {
    if (infoApi?.length < 1 || infoApi === undefined) return;
    infoApi?.forEach((element) => {
      setUrlApi(element.urlApi);
      setCodRecaptcha(element.cod_recaptcha);
    });
  }, [infoApi]);

  return (
    <>
      <SidebarActivarCuenta
        urlApi={urlApi}
        codRecaptcha={codRecaptcha}
        show={mostrarModalActivarCuenta}
        setShow={setMostrarModalActivarCuenta}
        setShowLogin={setMostrarLogin}
        setShowModalActivaSuccess={setShowModalActivaSuccess}
        setObjUsuarioLogin={setObjUsuarioLogin}
        setLoading={setLoading}
      />

      <div
        className="container-fluid activar__cuenta"
        style={{
          paddingTop: "30px",
          paddingBottom: "60px",
        }}
      >
        {/* MOBILE */}
        <div className="row d-block d-lg-none">
          <div className="col-11" style={{ margin: "auto" }}>
            <div className="row">
              <div className="col-12 activar_cuenta_btn">
                <button className="banner__button" onClick={openActivarCuenta}>
                  ACTIVA TU CUENTA
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-12 pt-5 activar_cuenta_texto__titulo">
                <h1>¿Cómo activar mis beneficios?</h1>
                <p className="pasos_text">
                  Para activar tu cuenta sólo debes seguir 3 simples pasos:
                </p>
              </div>
            </div>
            <div className="row" style={{ padding: "0 4rem" }}>
              <div className="pasos_col">
                <img
                  src="/assets/img/homeout/activar-cuenta/haz-clic.svg"
                  alt=""
                />
                <h3 className="pasos_titulo">Haz clic</h3>
                <p className="pasos_text">
                  Haz clic al botón
                  <br />
                  "Activa tu cuenta"
                </p>
              </div>
              <hr className="activa__underline"></hr>
              <div className="pasos_col">
                <img
                  src="/assets/img/homeout/activar-cuenta/completa.svg"
                  alt=""
                />
                <h3 className="pasos_titulo">Completa</h3>
                <p className="pasos_text">
                  Ingresa tus datos al formulario, a modo de registro
                </p>
              </div>
              <hr className="activa__underline"></hr>
              <div className="pasos_col">
                <img
                  src="/assets/img/homeout/activar-cuenta/disfruta.svg"
                  alt=""
                />
                <h3 className="pasos_titulo">¡Listo!</h3>
                <p className="pasos_text">
                  Disfruta de los beneficios totalmente gratuitos que tenemos
                  para ti
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* DESKTOP */}
        <div className="row div__pasos__activar d-none d-lg-block">
          <div className="col-2"></div>

          <div className="col-8" style={{ margin: "auto" }}>
            <div className="row">
              <div className="col-12 activar_cuenta_btn">
                <button className="banner__button" onClick={openActivarCuenta}>
                  ACTIVAR BENEFICIOS
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-12 pt-5 activar_cuenta_texto__titulo">
                <h1>¿Cómo activar tus beneficios?</h1>
                <p className="pasos_text">
                  Para activar tu cuenta sólo debes seguir 3 simples pasos:
                </p>
              </div>
            </div>

            <div className="row d-none d-lg-flex">
              <div
                className="col-4 pasos_col"
                style={{ borderRight: "2px solid var(--principal)" }}
              >
                <img
                  src="/assets/img/homeout/activar-cuenta/haz-clic.svg"
                  alt=""
                />
                <h3 className="pasos_titulo">Haz clic</h3>
                <p className="pasos_text">
                  Haz clic al botón
                  <br />
                  "Activa tu cuenta"
                </p>
              </div>
              <div
                className="col-4 pasos_col"
                style={{ borderRight: "2px solid var(--principal)" }}
              >
                <img
                  src="/assets/img/homeout/activar-cuenta/completa.svg"
                  alt=""
                />
                <h3 className="pasos_titulo">Completa</h3>
                <p className="pasos_text">
                  Ingresa tus datos al formulario, a<br />
                  modo de registro
                </p>
              </div>
              <div className="col-4 pasos_col">
                <img
                  src="/assets/img/homeout/activar-cuenta/disfruta.svg"
                  alt=""
                />
                <h3 className="pasos_titulo">¡Listo!</h3>
                <p className="pasos_text">
                  Disfruta de los beneficios
                  <br />
                  que tenemos para ti
                </p>
              </div>
            </div>
          </div>

          <div className="col-2"></div>
        </div>
      </div>
    </>
  );
};
